export default {
  functional: true,

  name: 'v-list-tile-action',

  render: function render(h, _ref) {
    var data = _ref.data,
        children = _ref.children;

    data.staticClass = data.staticClass ? 'list__tile__action ' + (data.staticClass || '') : 'list__tile__action';
    if ((children || []).length > 1) data.staticClass += ' list__tile__action--stack';

    return h('div', data, children);
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/vuetify/es5/components/VList/VListTileAction.js
// module id = A9FO
// module chunks = 0